<template>
  <v-container fluid pa-0>
    <h1 class="headline">Documents Contents</h1>
    <contents owner-name="DOCUMENT" owner-id="0" />
  </v-container>
</template>

<script>
import Contents from "../../../gt/shared/contents/Contents";
export default {
  name: "DocumentsContents",
  components: {
    Contents
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/contents/DocumentsContents.vue